import axios from 'axios'

const userApi = {
  Logout: '/auth/logout',
  ForgePassword: '/auth/forge-password',
  Register: '/auth/register',
  twoStepCode: '/auth/2step-code',
  SendSms: '/account/sms',
  SendSmsErr: '/account/sms_err',
  // get my info
  UserInfo: '/user/info',
  UserMenu: '/user/nav'
}

/**
 * 动态登录，pif天翼通物流
 * @param parameter
 * @returns {*}
 */
export function login(parameter) {
  return axios.post('https://api.piflogistics.com/auth/login', parameter)
    .then(response => {
      return response.data
    })
    .catch(error => {
      // 处理错误
      if (error.response) {
        // 服务器返回了错误状态码
        const errorMessage = error.response.data?.message || error.response.data?.error || '登录失败'
        return Promise.reject(new Error(errorMessage))
      } else if (error.request) {
        // 请求已发出但没有收到响应
        return Promise.reject(new Error('网络错误，请检查网络连接'))
      } else {
        // 其他错误
        return Promise.reject(error)
      }
    })
}
